import { CALL_API } from '../store/api';

export const UPDATE_SEARCH_PARAMS_REQUEST = 'UPDATE_SEARCH_PARAMS_REQUEST';
export const RESET_SEARCH_PARAMS_REQUEST = 'RESET_SEARCH_PARAMS_REQUEST';

export const SEARCH_CONFIG_REQUEST = "SEARCH_CONFIG_REQUEST"; 
export const SEARCH_CONFIG_SUCCESS = "SEARCH_CONFIG_SUCCESS"; 
export const SEARCH_CONFIG_FAILURE = "SEARCH_CONFIG_FAILURE";

export const AUTOCOMPLETE_REQUEST = "AUTOCOMPLETE_REQUEST"; 
export const AUTOCOMPLETE_SUCCESS = "AUTOCOMPLETE_SUCCESS"; 
export const AUTOCOMPLETE_FAILURE = "AUTOCOMPLETE_FAILURE";

export const SEARCH_SORT_OPTIONS_REQUEST = "SEARCH_SORT_OPTIONS_REQUEST"; 
export const SEARCH_SORT_OPTIONS_SUCCESS = "SEARCH_SORT_OPTIONS_SUCCESS"; 
export const SEARCH_SORT_OPTIONS_FAILURE = "SEARCH_SORT_OPTIONS_FAILURE";

export const updateSearchFilters = (filters) => (dispatch, getState) => {
    return dispatch({type: UPDATE_SEARCH_PARAMS_REQUEST, filters: filters})
}

export const resetSearchFilters = () => (dispatch, getState) => {
    return dispatch({type: RESET_SEARCH_PARAMS_REQUEST})
}

export const fetchSearchConfig = () => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [SEARCH_CONFIG_REQUEST, SEARCH_CONFIG_SUCCESS, SEARCH_CONFIG_FAILURE],
            method: 'GET',
            endpoint: 'listings/filter/config',            
        }
    });
};

export const fetchAutoCompleteSuggestions = (query) => ({
    [CALL_API]: {
        types: [AUTOCOMPLETE_REQUEST, AUTOCOMPLETE_SUCCESS, AUTOCOMPLETE_FAILURE],
        method: 'GET',        
        endpoint: `listings/terms?term=${query}`
    },
    query: query
});

export const fetchSearchSortOptions = () => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [SEARCH_SORT_OPTIONS_REQUEST, SEARCH_SORT_OPTIONS_SUCCESS, SEARCH_SORT_OPTIONS_FAILURE],
            method: 'GET',
            endpoint: 'listings/sortOptions',            
        }
    });
};